import React from "react";
import { useLang } from "../context/LanguageContext";
import { Eyebrow } from "../components/Bits";

export default function About() {
  const { t } = useLang();
  return (
    <div className="max-w-[900px] mx-auto px-5 lg:px-8 py-16" data-testid="about-page">
      <Eyebrow>{t("about.eyebrow")}</Eyebrow>
      <h1 className="font-display text-4xl sm:text-5xl text-white mt-2">{t("about.title")}</h1>
      <p className="text-white/70 mt-5 text-lg leading-relaxed">{t("about.body")}</p>
      <p className="text-white/50 mt-4">{t("home.tagline")}</p>
    </div>
  );
}
